<template>
  <f7-page name="aktualne-pocasie-detail" @page:init="onPageInit" @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding><template v-if="isDataLoaded">{{ stationMeta.station_name }} - </template>Aktuálne počasie</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-block strong class="no-padding no-margin no-border-top">
      <template v-if="isStationsLoaded">

         <aktualne-pocasie-mesto v-if="isDataLoaded" :station-data="stationData" :station-meta="stationMeta"></aktualne-pocasie-mesto>

      </template>
    </f7-block>



  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import AktualnePocasieMesto from "../components/aktualne-pocasie-mesto";


export default {
  components: {
    AktualnePocasieMesto
  },
  data: function () {
    // var productId = this.$f7route.params.id; // ziskanie parametra z url
    return {
      // products: this.$f7.data.products, // ziskanie udajov z globalneho data
      stations: [],
      stationData: {},
      selectedStationId: null,
      isStationsLoaded: false,
      isDataLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
      mapTabChanged: 0,
      reloadInvoked: 0,
    };
  },
  computed : {
    iconType: function()
    {
      let hh = this.$moment.unix(this.stationData.dt).format('H');
      if (hh < 7 || hh > 19) return 'noc';
      return 'den';
    },
    stationMeta: function () {
      return this.stations.find(station => parseInt(station.station_id) === parseInt(this.selectedStationId));
    },
    windKmh: function () {
      if (this.stationData.v_rychlost) {
        return Math.round(this.stationData.v_rychlost * 3.6 * 10) / 10;
      }
      return null;
    },
    windNarazyKmh: function () {
      if (this.stationData.fm) {
        return Math.round(this.stationData.fm * 3.6 * 10) / 10;
      }
      return null;
    }


  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

  },
  updated() {
  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        self.selectedStationId = this.$f7route.params.station_id;

        this.reloadInvoked = Math.random();
        let cached_stations = self.$ls.get('actual_weather_stations');
        if (cached_stations !== null) {
          self.stations = cached_stations;
          self.isStationsLoaded = true;
          self.loadStationData();
          self.$f7.dialog.close();
        } else {

          self.$f7.dialog.preloader('Načítavam...');

          Axios.get(SHMUconf.API_BASE_URL + 'meteo/getactualweatherstations', {
            crossDomain: true,
            cache: false,
          })
              .then((response) => {
                if (!response.data.error) {
                  self.stations = response.data;
                  self.isStationsLoaded = true;
                  self.$ls.set('actual_weather_stations', self.stations, 24 * 60 * 60 * 1000); // 1 den
                  self.loadStationData();
                } else {
                  self.$f7.dialog.alert('Nepodarilo sa načítať zoznam staníc aktuálneho počasia', 'Nastala chyba');
                }
                self.$f7.dialog.close();

              }).catch((error) => {
            self.$f7.dialog.close();
            self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
          });
        }
      }

    },
    loadStationData() {
      const self = this;

      if (this.selectedStationId === null) {
        // ak nie je vybrana stanica, nic nerobime, v updated funkcii sa otvori vyber stanic
      } else {
        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getactualweatherdata?station=' + this.selectedStationId, {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.stationData = response.data[0];
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();

                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60*1000); // overujem kazdu minutu

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne údaje k stanici', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    onPageBeforeOut() {
      const self = this;
      // console.log('onPageBeforeOut');
      // Close opened sheets on page out
      self.$f7.popover.close();
    },
    onPageBeforeRemove() {
      const self = this;
      //   console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.popover) self.popover.destroy();
    },


  }

};
</script>

